import * as React from "react";

import { Alignment, Classes, H3, H5, InputGroup, Navbar, Switch, Tab, TabId, Tabs,Card } from "@blueprintjs/core";
import { Example, handleBooleanChange, IExampleProps } from "@blueprintjs/docs-theme";
import CardDocuments from './CardDocuments.tsx';
import CardDocumentsConfig from './CardDocumentsConfig.tsx';
import CardDocumentsEnseignants from "./CardDocumentsEnseignants.tsx";
import './TabsDocuments.css';

export interface ITabsExampleState {
    activePanelOnly: boolean;
    animate: boolean;
    navbarTabId: TabId;
    vertical: boolean;
    matiere_id:string;
    userid:string;
    mustrefresh:boolean;
    isnotdocument:string;
    pageid:string;
    initialpageid:string;
    data:[];
    datacours:[];
    dataclassesetudiants:[];
    coursopenwidth:Number;
}

export  class TabsDocumentsEnseignant extends React.PureComponent<IExampleProps, ITabsExampleState> {
    constructor(props) {
        super(props);
        console.log("TabsDocumentsEnseignant");
        console.log(props);
        this.LoadData = this.LoadData.bind(this); 
      }
    public state: ITabsExampleState = {
        activePanelOnly: false,
        animate: true,
        navbarTabId: "",
        vertical: true,
        matiere_id:"0",
        userid:"",
        mustrefresh:false,
        isnotdocument:'none',
        pageid:'',
        initialpageid:'cours',
        data:[],
        datacours:[],
        dataclassesetudiants:[],
        coursopenwidth:180
    };
    componentDidMount () {
        this.setState({userid:this.props.userid});
        this.setState({pageid:this.props.pageid});
        this.setState({dataclassesetudiants:this.props.dataclassesetudiants});
        //console.log(this.props.dataclassesetudiants);
        //this.setState({initialpageid:this.props.pageid});
        this.setState({isnotdocument:this.props.isnotdocument});
        this.LoadData();
    }
    componentDidUpdate(prevProps, prevState) {
        //console.log(prevProps);
        if(this.props.dataclassesetudiants!=this.state.dataclassesetudiants)this.setState({dataclassesetudiants:this.props.dataclassesetudiants});
        if(this.props.pageid!=prevState.pageid){
            this.setState({pageid:this.props.pageid});
            if(this.props.pageid==this.state.initialpageid)this.setState({mustrefresh:true});
        }
        if (this.state.mustrefresh) {this.LoadData();this.setState({mustrefresh:false});}
    }
LoadData=()=>
{
  var that=this;
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  //var that=_this;
  xhr.open('GET','/api/public/getmatieres?id_enseignant='+this.props.userid)
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE) {
                    
        if(xhr.status==200) 
        { 
        
        console.log(xhr.responseText);
        var jsonResponse = JSON.parse(xhr.responseText);
        console.log(jsonResponse);
        that.setState({data:jsonResponse});
        //setData(jsonResponse);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
         
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        
      
      }
      
  }
}
LoadDataCours=(stid)=>
{
  var that=this;
  var xhr = new XMLHttpRequest();
  xhr.overrideMimeType("application/json");
  
  //var that=_this;
  xhr.open('GET','/api/public/getcours?id_matiere='+ stid); //this.state.navbarTabId)
  
  xhr.setRequestHeader("Content-Type", "application/json");

  //send the form data
  xhr.send();

  xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE) {
                    
        if(xhr.status==200) 
        { 
        
        console.log(xhr.responseText);
        var jsonResponse = JSON.parse(xhr.responseText);
        console.log(jsonResponse);
        that.setState({datacours:jsonResponse});
        //setData(jsonResponse);
          //toaster.show( {message:"Matière "+ uMatiere.matiere + " créée"});
         
        }
        if(xhr.status==404) {console.log( {message:"erreur"}); }
        if(xhr.status==500) {console.log( {message:"erreur"}); }
        
      
      }
      
  }
}
    handlestate=(etat)=>
    {
        if(etat)this.setState({coursopenwidth:0});else this.setState({coursopenwidth:180});
    }
    private toggleActiveOnly = handleBooleanChange(activePanelOnly => this.setState({ activePanelOnly }));

    private toggleAnimate = handleBooleanChange(animate => this.setState({ animate }));

    private toggleVertical = handleBooleanChange(vertical => this.setState({ vertical }));
    private handleNavbarTabChange = (navbarTabId: TabId) => {this.setState({ navbarTabId });this.LoadDataCours(navbarTabId);}
    private handleCreationCours=function(){this.LoadDataCours(this.state.navbarTabId);}.bind(this);
    public render() {
      
        return (
            <div title={this.props.pageid} style={{display:this.props.isnotdocument, flex:'100%', width:'calc( 100% - 20px)',height:'auto',padding:'10px',minHeight: '800px',backgroundColor:"rgba(245,245,245,0.9", boxShadow :' 0 0 0 1px rgb(16 22 26 / 10%), 0 1px 1px rgb(16 22 26 / 20%), 0 2px 6px rgb(16 22 26 / 20%)'}}>
        
       
                {/* uncontrolled mode & each Tab has a panel: */}
                <Tabs
                    style={{width:'100%'}}
                    animate={this.state.animate}
                    id="TabsExample"
                    key={this.state.vertical ? "vertical" : "horizontal"}
                    renderActiveTabPanelOnly={this.state.activePanelOnly}
                    vertical={this.state.vertical}
                    onChange={this.handleNavbarTabChange}
                    large='true'
                >
                     {this.state.data.map(p => (
                        
                        <Tab style={{display:this.state.coursopenwidth==0?'none':'flex'}}  id={p.ID} title={p.matiere} panel={<MatierePanel coursopen={this.state.coursopenwidth==0} handlestate={this.handlestate} userid={this.props.userid}  onchildrenevent={this.handleCreationCours} dataclassesetudiants={this.state.dataclassesetudiants} datacours={this.state.datacours} style={{width:'100%'}} title={p.matiere} matiere_id={p.ID} />} />
                        
                    ))}
                   {/* <Tab style={{width:'100%'}} id="mu" title="Musique" panel={<MatierePanel style={{width:'100%'}}  matiere_id="1" />} />
                    <Tab id="ng" title="Anglais" panel={<MatierePanel matiere_id="2" />} />
                    <Tab id="mb" title="Découverte" panel={<MatierePanel matiere_id="3"  />} />
                     <Tab id="bb" disabled={true} title="A venir..." panel={<MatierePanel matiere_id="30"  />} />*/}
                    <Tabs.Expander />
                    {/*<InputGroup className={Classes.FILL} type="text" placeholder="Search..." />*/}
                </Tabs>
            </div>
        );
    }
    //private handleNavbarTabChange = (navbarTabId: TabId) => this.setState({ navbarTabId });
    
}

const MatierePanel: React.FunctionComponent = (props) => (
    <div>
         <CardDocumentsConfig {...props}  title_lesson={"Ajouter un cours dans la matière "+props.title} lesson_description="Dans chaque cours vous pourrez mettre des documents" config='true' youtube_frame='false' matiere_id={props.matiere_id}/>
         <div style={{display:'flex',flexWrap:'wrap'}}>
         {props.datacours.map(p => (
                        
                        <CardDocumentsEnseignants {...props} coursopen={props.coursopen} handlestate={props.handlestate} toolbar='true' title_lesson={p.nom} lesson_description={p.description} publication={p.publication} id_cours={p.ID}/>
                        
                    ))}
         </div>
    </div>
);



